import clsx from 'clsx';
import Image from 'next/image';
import styles from './index.module.scss';
import Link from 'next/link';
import { FC, useMemo } from 'react';
import UISize from '@/enums/ui-size.enum';
import CommonElementProps from '@/types/common-element-props.type';
type Props = Partial<{
  size: UISize;
  hasName: boolean;
}> &
  CommonElementProps;
const AppLogo: FC<Props> = ({ size = UISize.SMALL, className, hasName = false }) => {
  const classNames = clsx(styles.logo, 'horizontal-center', className && className);

  const width = useMemo((): number => {
    switch (size) {
      case UISize.SMALL:
        return 32;
      case UISize.MEDIUM:
        return 40;
      case UISize.LARGE:
        return 60;
      default:
        return 20;
    }
  }, [size]);

  return (
    <Link href="/" className={classNames}>
      <Image
        src="/images/logo/gramvey-shape-logo.svg"
        width={width}
        height={width}
        alt="Gramvey Logo"
        className={styles.logo__img}
      />
      {hasName && <h3 className={styles.logo__label}>Gramvey</h3>}
    </Link>
  );
};

export default AppLogo;
